export const deepCopy = (obj) => {
  return Object(JSON.parse(JSON.stringify(obj)))
}

export const formatIntl = (number, locale='nl-NL', options={}) => {
  // international formatting for a number
  const formatter = new Intl.NumberFormat(locale, options)
  return formatter.format(number)
}

export const splitFloat = (number) => {
  // separately return the part before and after the comma of a number
  return [
    Math.trunc(number).toString(),
    Math.round((number % 1) * 100).toString().padStart(2, 0),
  ]
}

export const round = (num, amountOfDecimals=0) => {
  // round num to amountOfDecimals
  return parseFloat(num.toFixed(amountOfDecimals))
}
